import { AlertTriangle, Wrench } from 'lucide-react';
import { Card } from '@/components/ui/card';

interface MaintenanceModeProps {
  message?: string;
}

export const MaintenanceMode = ({ message }: MaintenanceModeProps) => {
  return (
    <div className='min-h-screen bg-background flex items-center justify-center p-4'>
      <Card className='max-w-md w-full p-8 text-center space-y-6'>
        <div className='flex justify-center'>
          <div className='relative'>
            <Wrench className='size-16 text-primary animate-pulse' />
            <AlertTriangle className='size-6 text-destructive absolute -top-1 -right-1' />
          </div>
        </div>

        <div className='space-y-3'>
          <h1 className='text-2xl font-bold text-foreground'>
            System Maintenance
          </h1>
          <p className='text-muted-foreground'>
            {message?.trim() ||
              "We're currently performing scheduled maintenance to improve your experience."}
          </p>
        </div>

        <div className='space-y-2'>
          <p className='text-xs text-muted-foreground'>
            We apologize for any inconvenience and appreciate your patience.
          </p>
        </div>
      </Card>
    </div>
  );
};
